class EventBus {
  private static instance: EventBus
  private readonly listeners: Map<string, Set<EventListener>>

  private constructor() {
    this.listeners = new Map()
  }

  static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus()
    }
    return EventBus.instance
  }

  on<T = any>(eventName: string, callback: (data: T) => void): EventListener {
    const listener = ((event: Event) => {
      if (event instanceof CustomEvent) {
        callback(event.detail)
      }
    }) as EventListener

    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set())
    }

    this.listeners.get(eventName)?.add(listener)

    globalThis.addEventListener(eventName, listener)

    return listener
  }

  emit<T = any>(eventName: string, data?: T): void {
    const event = new CustomEvent(eventName, { detail: data })
    globalThis.dispatchEvent(event)
  }

  remove(eventName: string, listener: EventListener): void {
    globalThis.removeEventListener(eventName, listener)

    const listeners = this.listeners.get(eventName)
    if (listeners) {
      listeners.delete(listener)
      if (listeners.size === 0) {
        this.listeners.delete(eventName)
      }
    }
  }
}

const eventBus = EventBus.getInstance()

export default eventBus
